module.exports = {"data":{"site":{"siteMetadata":{"title":"HistoriArg"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 117
// module chunks = 60335399758886 114276838955818